const UNINITIALIZED_PROVIDER = "You used the hook with no provider";
export const throwUninitializedContextError = () => {
  throw new Error(UNINITIALIZED_PROVIDER);
};
